export default "__VITE_ASSET__c5f2217e__"